import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanTemplateTodoSchema, PlanTodoSchema } from './shapes';

export const addPlanTodo = defineEndpoint({
  method: 'POST',
  path: '/v1/release-plans/:planId/sections/:sectionId/todos',
  params: z.object({ planId: z.string().uuid(), sectionId: z.string().uuid() }),
  query: z.object({}),
  body: PlanTemplateTodoSchema,
  response: z.object({ data: PlanTodoSchema }),
  successStatus: 201,
});
